import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";

@Injectable({
  providedIn: "root",
})
export class PwaService {
  public promptEvent: any;
  public isIos: boolean;

  constructor(private swUpdate: SwUpdate) {
    let userAgents: any = window.navigator.userAgent.toLowerCase();
    this.isIos = /iphone|ipad|ipod/.test(userAgents);

    window.addEventListener("beforeinstallprompt", (event) => {
      this.promptEvent = event;
      // event.preventDefault();
    });

    window.addEventListener("appinstalled", (event) => {
      //this.promptEvent = null;
    });

    this.swUpdate.available.subscribe((event) => {});
  }
}
